import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AddProjectWorkflowLineNotesDto } from "../../../core/models/project-workflow/addProjectWorkflowLineNotesDto";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { DrawerModule } from "primeng/drawer";
import { ButtonModule } from "primeng/button";

@Component({
  selector: "jni-workflow-line-notes",
  templateUrl: "./workflow-line-notes.component.html",
  styleUrls: ["./workflow-line-notes.component.scss"],
  imports: [FormsModule, CommonModule, DrawerModule, ButtonModule],
})
export class WorkflowLineNotesComponent implements OnInit {
  @Input() notes = "";
  @Input() display!: boolean;
  @Input() projectWorkflowId = 0;
  @Input() lineRecId = 0;
  @Input() taskId = 0;
  @Input() type = "WorkflowLine";
  @Output() closeSidebar = new EventEmitter();
  @Output() displayChange = new EventEmitter<boolean>();
  @Output() saveNotesEvent = new EventEmitter<AddProjectWorkflowLineNotesDto>();

  heading = "";
  // onHide() {
  //   this.displayChange.emit(false);
  //   this.notes = "";
  //   this.closeSidebarModel();
  // }

  closeSidebarModel() {
    this.closeSidebar.emit();
  }

  saveNotes() {
    if (this.type === "WorkflowLine") {
      const request = {
        projectWorkflowId: this.projectWorkflowId,
        lineRecId: this.lineRecId,
        notes: this.notes,
      } as AddProjectWorkflowLineNotesDto;
      this.saveNotesEvent.emit(request);
    } else {
      const request = {
        taskId: this.taskId,
        notes: this.notes,
      };
      this.saveNotesEvent.emit(request);
    }
  }

  ngOnInit(): void {
    if (this.notes !== "") {
      this.heading = "Edit Notes";
    } else {
      this.heading = "Add Notes";
    }
  }
}
